import React from 'react';
import { PRIVACY_POLICY_URL } from '../utils/emailDomainValidation';

interface ApproverEmailDisclaimerProps {
  className?: string;
}

/** Legal notice shown when collecting approver emails/domains for a policy. */
const ApproverEmailDisclaimer: React.FC<ApproverEmailDisclaimerProps> = ({
  className = 'dash-form-hint',
}) => (
  <small className={className}>
    These are other people&apos;s addresses. By entering them you confirm you may share them with
    us for this purpose, and that you have told them, or will tell them, that they have been
    designated as approvers. We contact them only to request approvals, and our{' '}
    <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
      privacy notice
    </a>{' '}
    explains their rights.
  </small>
);

export default ApproverEmailDisclaimer;
